module.exports = __webpack_public_path__ + "img/古灵女.1f92d902.png";